const groups = [
  {
    title: "产品能力",
    items: [
      { label: "文字提取", href: "#features" },
      { label: "图片提取", href: "#features" },
      { label: "视频解析", href: "#features" },
      { label: "源码查看", href: "#features" },
    ],
  },
  {
    title: "快速导航",
    items: [
      { label: "快速体验", href: "#demo" },
      { label: "使用步骤", href: "#steps" },
      { label: "适用场景", href: "#scenes" },
      { label: "常见问题", href: "#faq" },
    ],
  },
];

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-200">
      <div className="container-x">
        <div className="grid gap-10 py-12 md:grid-cols-4">
          <div className="md:col-span-2">
            <a href="#top" className="flex items-center gap-2.5" aria-label="吃瓜网页 回到顶部">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-gradient-to-br from-primary-500 to-primary-700 text-background-50">
                <i className="ri-scissors-2-line text-lg" aria-hidden="true" />
              </span>
              <span className="font-heading text-xl text-foreground-900">吃瓜网页</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              一款帮你提取网页文字、图片、视频、链接与数据的在线工具。吃瓜有料、素材好存，让每一页内容都能被随时调用。
            </p>
            <p className="mt-4 text-xs text-foreground-500">
              建议与反馈：<a href="mailto:hello@chigua-web.top" className="text-primary-600 hover:underline">hello@chigua-web.top</a>
            </p>
          </div>

          {groups.map((g) => (
            <div key={g.title}>
              <h4 className="text-sm font-bold text-foreground-900">{g.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {g.items.map((it) => (
                  <li key={it.label}>
                    <a
                      href={it.href}
                      className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {it.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="flex flex-col gap-3 border-t border-background-300/70 py-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">© {new Date().getFullYear()} 吃瓜网页 · 保留所有权利</p>
          <p className="text-xs text-foreground-500">
            请遵守相关网站使用条款，尊重原创内容版权，注明出处合理使用。
          </p>
        </div>
      </div>
    </footer>
  );
}